import { applyWatercolorEffect } from './painting/WatercolorEffect';
import { applyOilPaintingEffect } from './painting/OilPaintingEffect';
import { applyAcrylicEffect } from './painting/AcrylicEffect';
import { applyPenDrawingEffect } from './painting/PenDrawingEffect';
import { applyPencilDrawingEffect } from './painting/PencilDrawingEffect';
import { applyPastelEffect } from './painting/PastelEffect';

import { applyRealismStyle } from './artstyles/RealismStyle';
import { applyImpressionismStyle } from './artstyles/ImpressionismStyle';
import { applyPostImpressionismStyle } from './artstyles/PostImpressionismStyle';
import { applyExpressionismStyle } from './artstyles/ExpressionismStyle';
import { applyCubismStyle } from './artstyles/CubismStyle';
import { applyAbstractStyle } from './artstyles/AbstractStyle';
import { applySurrealismStyle } from './artstyles/SurrealismStyle';
import { applyPopArtStyle } from './artstyles/PopArtStyle';
import { applyMinimalismStyle } from './artstyles/MinimalismStyle';
import { applyBaroqueStyle } from './artstyles/BaroqueStyle';
import { applyRococoStyle } from './artstyles/RococoStyle';
import { applyRomanticismStyle } from './artstyles/RomanticismStyle';
import { applyClassicismStyle } from './artstyles/ClassicismStyle';
import { applyFauvismStyle } from './artstyles/FauvismStyle';
import { applyPointillismStyle } from './artstyles/PointillismStyle';
import { applyInkWashStyle } from './artstyles/InkWashStyle';
import { applyOrientalBirdStyle } from './artstyles/OrientalBirdStyle';
import { applyOrientalLandscapeStyle } from './artstyles/OrientalLandscapeStyle';

export const applyPaintingMode = async (canvas, ctx, paintingStyle, artStyle, setMessage, language) => {
  // 단계별 진행상황 표시
  setMessage(language === 'KR' ? '그림 모드 적용 중 (1/3) - 표현방식 적용...' : 'Applying Painting Mode (1/3) - Applying painting style...');
  await new Promise(resolve => setTimeout(resolve, 500));

  // 1. 표현방식 적용
  switch (paintingStyle) {
    case 'watercolor':
      await applyWatercolorEffect(canvas, ctx, setMessage, language);
      break;
    case 'oil':
      await applyOilPaintingEffect(canvas, ctx, setMessage, language);
      break;
    case 'acrylic':
      await applyAcrylicEffect(canvas, ctx, setMessage, language);
      break;
    case 'pen':
      await applyPenDrawingEffect(canvas, ctx, setMessage, language);
      break;
    case 'pencil':
      await applyPencilDrawingEffect(canvas, ctx, setMessage, language);
      break;
    case 'pastel':
      await applyPastelEffect(canvas, ctx, setMessage, language);
      break;
    default:
      await applyWatercolorEffect(canvas, ctx, setMessage, language);
  }

  // 2. 화풍 적용
  setMessage(language === 'KR' ? '그림 모드 적용 중 (2/3) - 화풍 적용...' : 'Applying Painting Mode (2/3) - Applying art style...');
  await new Promise(resolve => setTimeout(resolve, 500));

  switch (artStyle) {
    case 'realism':
      await applyRealismStyle(canvas, ctx, setMessage, language);
      break;
    case 'impressionism':
      await applyImpressionismStyle(canvas, ctx, setMessage, language);
      break;
    case 'postimpressionism':
      await applyPostImpressionismStyle(canvas, ctx, setMessage, language);
      break;
    case 'expressionism':
      await applyExpressionismStyle(canvas, ctx, setMessage, language);
      break;
    case 'cubism':
      await applyCubismStyle(canvas, ctx, setMessage, language);
      break;
    case 'abstract':
      await applyAbstractStyle(canvas, ctx, setMessage, language);
      break;
    case 'surrealism':
      await applySurrealismStyle(canvas, ctx, setMessage, language);
      break;
    case 'popart':
      await applyPopArtStyle(canvas, ctx, setMessage, language);
      break;
    case 'minimalism':
      await applyMinimalismStyle(canvas, ctx, setMessage, language);
      break;
    case 'baroque':
      await applyBaroqueStyle(canvas, ctx, setMessage, language);
      break;
    case 'rococo':
      await applyRococoStyle(canvas, ctx, setMessage, language);
      break;
    case 'romanticism':
      await applyRomanticismStyle(canvas, ctx, setMessage, language);
      break;
    case 'classicism':
      await applyClassicismStyle(canvas, ctx, setMessage, language);
      break;
    case 'fauvism':
      await applyFauvismStyle(canvas, ctx, setMessage, language);
      break;
    case 'pointillism':
      await applyPointillismStyle(canvas, ctx, setMessage, language);
      break;
    case 'inkwash':
      await applyInkWashStyle(canvas, ctx, setMessage, language);
      break;
    case 'oriental_bird':
      await applyOrientalBirdStyle(canvas, ctx, setMessage, language);
      break;
    case 'oriental_landscape':
      await applyOrientalLandscapeStyle(canvas, ctx, setMessage, language);
      break;
    default:
      await applyRealismStyle(canvas, ctx, setMessage, language);
  }

  // 3. 최종 조정
  setMessage(language === 'KR' ? '그림 모드 적용 중 (3/3) - 최종 조정...' : 'Applying Painting Mode (3/3) - Final adjustments...');
  await new Promise(resolve => setTimeout(resolve, 500));

  // 그림 같은 질감 추가를 위한 최종 처리
  const finalData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const finalPixels = finalData.data;

  // 약간의 노이즈와 질감 추가
  for (let i = 0; i < finalPixels.length; i += 4) {
    if (Math.random() > 0.98) { // 2% 확률로 질감 추가
      const textureAmount = (Math.random() - 0.5) * 15;
      
      for (let c = 0; c < 3; c++) {
        finalPixels[i + c] = Math.min(255, Math.max(0, finalPixels[i + c] + textureAmount));
      }
    }
  }

  ctx.putImageData(finalData, 0, 0);

  // 처리 완료
  setMessage(language === 'KR' ? '그림 모드 적용 완료!' : 'Painting Mode applied!');
};